<template>
  <div class="substitutions-wrapper" v-if="chatMessages.length === 0">
    <div class="promt__substitution" v-for="(substitution, index) in randomSubstitutions" :key="index">
      <div class="promt__substitution__text-wrapper">
        <paragraph-size-medium :textColor="'var(--text-black)'">{{ substitution.heading }}</paragraph-size-medium>
        <paragraph-size-small :textColor="'var(--text-secondary)'">{{ substitution.substitude }}</paragraph-size-small>
      </div>
      <button class="promt__substitution__button-paste" @click="insertText(substitution)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M4 7.33203C4 5.4467 4 4.50336 4.586 3.91803C5.17133 3.33203 6.11467 3.33203 8 3.33203H10C11.8853 3.33203 12.8287 3.33203 13.414 3.91803C14 4.50336 14 5.4467 14 7.33203V10.6654C14 12.5507 14 13.494 13.414 14.0794C12.8287 14.6654 11.8853 14.6654 10 14.6654H8C6.11467 14.6654 5.17133 14.6654 4.586 14.0794C4 13.494 4 12.5507 4 10.6654V7.33203Z" stroke="#D8473A" stroke-width="1.5"/>
          <path d="M4 12.6654C3.46957 12.6654 2.96086 12.4547 2.58579 12.0796C2.21071 11.7045 2 11.1958 2 10.6654V6.66536C2 4.15136 2 2.89403 2.78133 2.11336C3.562 1.33203 4.81933 1.33203 7.33333 1.33203H10C10.5304 1.33203 11.0391 1.54274 11.4142 1.91782C11.7893 2.29289 12 2.8016 12 3.33203" stroke="#D8473A" stroke-width="1.5"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import substitutions from '../substitutions.js';

import ParagraphSizeMedium from '@/components/UI/texts/paragraphs/ParagraphSizeMedium.vue';
import ParagraphSizeSmall from '@/components/UI/texts/paragraphs/ParagraphSizeSmall.vue';

export default {
  name: 'substitutions',
  components:{
    ParagraphSizeMedium,
    ParagraphSizeSmall
  },
  data(){
    return{
      substitutions: substitutions,
      windowWidth: window.innerWidth,
    }
  },
  props: {
    chatMessages: Array,
  },
  methods: {
    insertText(textToInsert) {
      this.$emit('insert-text', textToInsert);
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    randomSubstitutions() {
      const shuffled = this.substitutions.sort(() => 0.5 - Math.random());
      let result;
      switch (true) {
        default:
          result = shuffled.slice(0, 4);
      }
      return result;
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
};
</script>

<style scoped>
.substitutions-wrapper{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  margin-bottom: 16px;
}
.promt__substitution{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 170px;
  height: 170px;
  padding: 16px 8px;
  border-radius: 8px;
  background: var(--white);
  box-shadow: 4px 0px 16px 0px rgba(74, 74, 74, 0.15);
}
.promt__substitution__text-wrapper{
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
}
.promt__substitution__button-paste{
  background-color: transparent;
  border: none;
  outline: none;
  width: 32px;
  height: 32px;
  transition: 0.3s ease-in-out;
}
.promt__substitution__button-paste:hover{
  background-color: #F7F7F7;
  border-radius: 100px;
  transition: 0.3s ease-in-out;
}
@media screen and (max-width: 992px) {
  .substitutions-wrapper{
    /* grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 16px; */
    display: none;
  }
}
@media screen and (max-width: 568px) {
  .substitutions-wrapper{
    /* grid-template-columns: repeat(1, 1fr); */
    /* grid-column-gap: 16px; */
  }
}
</style>
